export const environment = {
  BASE_URL: "https://de-link.cainiao.com", // Local
  // urlTranslate: "https://api.ecoscooting.com:3010/",
  production: false,
};
